import React, { useState } from "react";
import IconPreview, { AddAndDeleteInlineIcon } from "../../../components/BuilderComponents/Preview/IconPreview";
import { useParams } from "react-router-dom";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { EditSubMenuModal } from "./NewHeaderRenderer";
import Label from "../../../components/FormComponents/Label";
import { useScreenContext } from "../../../context/ScreenContext";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";

const ScreenHeaderItem = ({ page, index, callBackAction, openEditIndex, setOpenEditIndex }) => {
  const openeEditMenuBar = (e) => {
    e.stopPropagation();
    setOpenEditIndex(openEditIndex === index ? null : index);
  };
  const editPage = (iconValue) => {
    callBackAction("edit_page", { index: index, icon: iconValue });
  };
  const deletePage = (e) => {
    e.stopPropagation();
    callBackAction("delete_page", { index: index });
  };

  return (
    <>
      <div
        key={index}
        className="pagelist_item headerDragNDrop_dragHandle"
        //   onClick={handleClick}
      >
        <div className={`header_menu_item screen_header_item`}>
          {page?.icon && <IconPreview icon={page.icon || ""} />}
          <span> {page.display}</span>
        </div>
        <div className="top_edit_del_icon">
          <MaterialIcon name="edit" className="builder_action_btn edit" onClick={openeEditMenuBar} />
          <MaterialIcon name="delete" className="builder_action_btn delete" onClick={deletePage} />
        </div>
      </div>
      {openEditIndex === index && (
        <EditHeaderPage page={page} editPageInHeader={editPage} setIsEditOpen={() => setOpenEditIndex(null)} />
      )}
    </>
  );
};

const EditHeaderPage = ({ page, editPageInHeader, setIsEditOpen }) => {
  const [selectedIcon, setSelectedIcon] = useState(page.icon || "");

  const callbackFunction = (data) => {
    setSelectedIcon(data);
    editPageInHeader(data);
  };

  return (
    <div className="sidebarView_edit_outer edit_open">
      <div className="sidebar_top_header">
        <span>Edit Header Page</span>
        <MaterialIcon name="close" className="section_close_darkIcon" onClick={() => setIsEditOpen(false)} />
      </div>
      <div className="d_flex align_center gap_2" style={{ padding: "12px" }}>
        <AddAndDeleteInlineIcon icon={selectedIcon || ""} callbackFunction={callbackFunction} />
        <Label>Add Icon</Label>
      </div>
    </div>
  );
};

export default ScreenHeaderItem;

const NestedDropdownItems = ({ items, onUpdateItems, allPages }) => {
  const [openSubIndex, setOpenSubIndex] = useState(null);
  const [editModalIndex, setEditModalIndex] = useState(null);
  const { screenId } = useParams();

  const handleRemoveItem = (subindex) => {
    onUpdateItems(items.filter((_, i) => i !== subindex));
  };

  const handleUpdateNestedItems = (subindex, newNestedItems) => {
    onUpdateItems(items.map((item, i) => (i === subindex ? { ...item, dropdown: newNestedItems } : item)));
  };

  const handleEditSubDropdown = (subindex, updatedSubmenu) => {
    onUpdateItems(
      items.map((item, i) =>
        i === subindex ? { ...item, display: updatedSubmenu.display, dropdown: updatedSubmenu.dropdown } : item
      )
    );
    setEditModalIndex(null);
  };

  return (
    <>
      {items.map((subPage, subindex) => {
        const isNestedDropdown = subPage.type === "dropdown" && subPage.dropdown?.length > 0;

        if (isNestedDropdown) {
          return (
            <div key={subindex} className="pagelist_item nested_dropdown_parent">
              <div className="nested_dropdown_header">
                <span>{subPage.display}</span>
                <div className="d_flex align_center gap_1">
                  <MaterialIcon
                    name="edit"
                    style={{ fontSize: "14px", cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditModalIndex(subindex);
                    }}
                  />
                  <MaterialIcon
                    name={openSubIndex === subindex ? "expand_less" : "expand_more"}
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenSubIndex(openSubIndex === subindex ? null : subindex);
                    }}
                  />
                  <MaterialIcon
                    name="remove"
                    className="submenu_item_remove"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveItem(subindex);
                    }}
                  />
                </div>
              </div>
              {openSubIndex === subindex && (
                <div className="nested_pagelist_submenu">
                  <NestedDropdownItems
                    items={subPage.dropdown}
                    onUpdateItems={(newItems) => handleUpdateNestedItems(subindex, newItems)}
                    allPages={allPages}
                  />
                </div>
              )}
              {editModalIndex === subindex && (
                <BuilderModal isOpen={true} onClose={() => setEditModalIndex(null)} modalName="Edit Sub-dropdown">
                  <EditSubMenuModal
                    allPages={allPages}
                    submenuName={subPage.display}
                    existingPages={subPage.dropdown || []}
                    callbackFunction={(updatedSubmenu) => handleEditSubDropdown(subindex, updatedSubmenu)}
                  />
                </BuilderModal>
              )}
            </div>
          );
        }

        return (
          <div key={subindex} className={`pagelist_item ${screenId === subPage.page_id ? "active" : ""}`}>
            <span>{subPage.display}</span>
            <MaterialIcon
              name="remove"
              className="submenu_item_remove"
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveItem(subindex);
              }}
            />
          </div>
        );
      })}
    </>
  );
};

const ScreenHeaderSubMenu = ({ page, index, callBackAction, menu, allPages, openEditIndex, setOpenEditIndex }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubModalOpen, setIsSubModalOpen] = useState(false);
  const { currentScreenData } = useScreenContext();

  const openEditMenuBar = (e) => {
    e.stopPropagation();
    setOpenEditIndex(openEditIndex === index ? null : index);
  };

  const editPage = (iconValue) => {
    callBackAction("edit_page", { index: index, icon: iconValue });
  };

  const deletePage = (e) => {
    e.stopPropagation();
    callBackAction("delete_page", { index: index });
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const submenuItemClassName = `${
    currentScreenData.device === "mobile"
      ? "pagelist_item_submenu_mobile screen_header_item"
      : "pagelist_item_submenu screen_header_item"
  }`;

  const handleUpdateDropdownItems = (newItems) => {
    const updatedPage = { ...page, dropdown: newItems };
    callBackAction("edit_sub_menu", { submenu: updatedPage, index });
  };

  return (
    <>
      <div key={index} className="pagelist_item headerDragNDrop_dragHandle" onClick={handleClick}>
        <div className={`header_menu_item screen_header_item`}>
          {page?.icon && <IconPreview icon={page.icon || ""} />}
          <span> {page.display}</span>
        </div>
        <div className="top_edit_del_icon">
          <MaterialIcon name="edit" className="builder_action_btn edit" onClick={openEditMenuBar} />
          <MaterialIcon name="delete" className="builder_action_btn delete" onClick={deletePage} />
          <span className="material-symbols-outlined builder_action_btn add">
            <SubMenuAction allPages={allPages} menu={menu} submenu={page} callBackAction={callBackAction} />
          </span>
        </div>
        <div className="header_submenu">
          {isOpen ? (
            <MaterialIcon name="expand_less" style={{ fontSize: "20px" }} />
          ) : (
            <MaterialIcon name="expand_more" style={{ fontSize: "20px" }} />
          )}
          {isOpen && (
            <div className={submenuItemClassName} onClick={(e) => e.stopPropagation()}>
              <NestedDropdownItems
                items={page.dropdown}
                onUpdateItems={handleUpdateDropdownItems}
                allPages={allPages}
              />
            </div>
          )}
        </div>
      </div>

      {openEditIndex === index && (
        <EditHeaderPage page={page} editPageInHeader={editPage} setIsEditOpen={() => setOpenEditIndex(null)} />
      )}

      <BuilderModal isOpen={isSubModalOpen} onClose={() => setIsSubModalOpen(false)} modalName="Edit SubMenu">
        <EditSubMenuModal
          allPages={allPages}
          menu={menu}
          callbackFunction={(subMenu) => {
            callBackAction("edit_sub_page", { index, submenu: subMenu });
            setIsSubModalOpen(false);
          }}
        />
      </BuilderModal>
    </>
  );
};

const SubMenuAction = ({ callBackAction, allPages, submenu, menu }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <MaterialIcon name="add" className="builder_action_btn add" onClick={() => setIsModalOpen(true)} />
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName={"Edit Submenu"}>
        <EditSubMenuModal
          allPages={allPages}
          submenuName={submenu.display}
          existingPages={submenu.dropdown}
          callbackFunction={(updatedSubmenu) => {
            callBackAction("edit_sub_menu", { submenu: updatedSubmenu, index: menu.indexOf(submenu) });
            setIsModalOpen(false);
          }}
          menu={menu}
        />
      </BuilderModal>
    </>
  );
};

export { ScreenHeaderSubMenu };
